import { render, staticRenderFns } from "./TermsAndDiscloseModal.vue?vue&type=template&id=7ede3cd3&scoped=true&"
import script from "./TermsAndDiscloseModal.vue?vue&type=script&lang=js&"
export * from "./TermsAndDiscloseModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndDiscloseModal.vue?vue&type=style&index=0&id=7ede3cd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ede3cd3",
  null
  
)

export default component.exports